import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/filter/box-open.svg'
import _imports_1 from '../../assets/filter/chevron-left-solid.svg'
import _imports_2 from '../../assets/filter/chevron-right-solid.svg'


const _withScopeId = n => (_pushScopeId("data-v-4f2f075e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column gap-5",
  id: "containerGeral"
}
const _hoisted_2 = { class: "d-flex flex-row justify-content-between align-items-center" }
const _hoisted_3 = { class: "d-flex flex-row gap-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 23 25",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M22.4652 18.2901V8.32579L12.548 14.0514C12.5258 14.0643 12.5034 14.0763 12.4807 14.0877V24.9995L21.7762 19.4984C22.2032 19.2457 22.4652 18.7863 22.4652 18.2901ZM9.66032 14.052L0 8.47456V18.2906C0 18.7868 0.26193 19.2462 0.688976 19.4989L9.98445 25V14.1829C9.87342 14.1554 9.76435 14.112 9.66032 14.052Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "0.3",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.303467 5.76705C0.421464 5.61804 0.570398 5.49211 0.744037 5.39963L10.5725 0.164817C10.9851 -0.054939 11.48 -0.054939 11.8926 0.164817L21.721 5.39963C21.8549 5.47092 21.974 5.56209 22.0757 5.66838L11.2998 11.8898C11.229 11.9307 11.1637 11.9775 11.1041 12.0292C11.0446 11.9775 10.9793 11.9307 10.9084 11.8898L0.303467 5.76705Z"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-around p-4 w-100\" id=\"header\" data-v-4f2f075e><span class=\"d-flex justify-content-center align-items-center subtitulo\" style=\"width:20%;\" id=\"veiculos\" data-v-4f2f075e>VEÍCULOS</span><span class=\"d-flex justify-content-center align-items-center subtitulo\" style=\"width:20%;\" id=\"titleList\" data-v-4f2f075e>ANO </span><span class=\"d-flex justify-content-center align-items-center subtitulo\" style=\"width:20%;\" id=\"titleList\" data-v-4f2f075e>FIPE </span><span class=\"d-flex justify-content-center align-items-center subtitulo\" style=\"width:20%;\" id=\"titleList\" data-v-4f2f075e>AÇÕES</span></div>", 1)
const _hoisted_6 = {
  key: 0,
  id: "results"
}
const _hoisted_7 = { style: {"width":"20%"} }
const _hoisted_8 = {
  class: "text-center",
  style: {"width":"20%"}
}
const _hoisted_9 = {
  class: "text-center",
  style: {"width":"20%"}
}
const _hoisted_10 = {
  class: "d-flex justify-content-center",
  style: {"width":"20%"}
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19.4492 5.55078L17.6484 7.35156C17.4648 7.53516 17.168 7.53516 16.9844 7.35156L12.6484 3.01562C12.4648 2.83203 12.4648 2.53516 12.6484 2.35156L14.4492 0.550781C15.1797 -0.179688 16.3672 -0.179688 17.1016 0.550781L19.4492 2.89844C20.1836 3.62891 20.1836 4.81641 19.4492 5.55078ZM11.1016 3.89844L0.84374 14.1562L0.0156149 18.9023C-0.0976663 19.543 0.460927 20.0977 1.10155 19.9883L5.84765 19.1562L16.1055 8.89844C16.2891 8.71484 16.2891 8.41797 16.1055 8.23438L11.7695 3.89844C11.582 3.71484 11.2851 3.71484 11.1016 3.89844ZM4.84765 13.2773C4.6328 13.0625 4.6328 12.7188 4.84765 12.5039L10.8633 6.48828C11.0781 6.27344 11.4219 6.27344 11.6367 6.48828C11.8516 6.70313 11.8516 7.04688 11.6367 7.26172L5.62108 13.2773C5.40624 13.4922 5.06249 13.4922 4.84765 13.2773ZM3.43749 16.5625H5.31249V17.9805L2.79296 18.4219L1.57811 17.207L2.01952 14.6875H3.43749V16.5625Z",
    fill: "#ED2B46"
  })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Editar", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "card d-flex h-100 justify-content-center",
  id: "empty"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "texto" }, "Use o filtro para pesquisar por um veículo", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-5",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  "clGestão": "",
  da: "",
  inass: "pagination d-flex justify-content-between p-4"
}
const _hoisted_20 = { style: {"min-width":"14rem","display":"flex","flex-direction":"column","align-items":"start"} }
const _hoisted_21 = { style: {"font-size":"14px"} }
const _hoisted_22 = {
  key: 0,
  style: {"font-size":"14px"}
}
const _hoisted_23 = {
  class: "d-flex flex-row gap-2 align-items-center justify-content-between",
  id: "paginationList"
}
const _hoisted_24 = { class: "d-flex flex-row justify-content-start" }
const _hoisted_25 = ["id", "disabled"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"12px"},
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["onClick", "id"]
const _hoisted_29 = { class: "d-flex flex-row justify-content-start" }
const _hoisted_30 = {
  key: 0,
  id: "lastPage",
  class: "me-2"
}
const _hoisted_31 = ["id", "disabled"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"12px"},
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_33 = [
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Button = _resolveComponent("Button")!
  const _component_filtro_lubrificantes = _resolveComponent("filtro-lubrificantes")!
  const _component_ModalInserirNosSelecionados = _resolveComponent("ModalInserirNosSelecionados")!
  const _component_ModalExcluirSelecionados = _resolveComponent("ModalExcluirSelecionados")!
  const _component_ModalEditarUnicoSelecionado = _resolveComponent("ModalEditarUnicoSelecionado")!
  const _component_ModalExcluirUnicoVeiculo = _resolveComponent("ModalExcluirUnicoVeiculo")!
  const _component_ModalEnviarPlanilha = _resolveComponent("ModalEnviarPlanilha")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.abaFiltro === true)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Title, null, {
              default: _withCtx(() => [
                _createTextVNode("Gestão da indicação")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Button, {
                text: "Filtro por produto",
                style: {"width":"max-content"},
                onClick: _cache[0] || (_cache[0] = () => _ctx.router.push('gestaoLubrificantes'))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_5,
            (!!_ctx.openListCars && !!_ctx.modelsYearListFiltered)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelsYearListFiltered, (myCar, key) => {
                    return _withDirectives((_openBlock(), _createElementBlock("li", { key: key }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("span", null, _toDisplayString(myCar.marca), 1),
                        _createElementVNode("span", null, " - " + _toDisplayString(myCar.modelo), 1)
                      ]),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(myCar?.ano), 1),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(myCar?.fipe), 1),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("button", {
                          class: "d-flex flex-row justify-content-center align-items-center",
                          onClick: ($event: any) => (_ctx.openModal('editarUnicoSelecionado'), _ctx.clickCar(myCar))
                        }, _hoisted_14, 8, _hoisted_11)
                      ])
                    ])), [
                      [_vShow, key >= (_ctx.state.currentPage - 1) * _ctx.state.itemsPerPage && key < _ctx.state.currentPage * _ctx.state.itemsPerPage]
                    ])
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18))
          ]),
          (_ctx.modelsYearListFiltered.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, "Exibindo " + _toDisplayString(_ctx.itemsOnPage.length) + " de " + _toDisplayString(_ctx.modelsYearListFiltered.length) + " veículos.", 1),
                  (_ctx.modelsYearListFiltered.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, " Veículos encontrados: " + _toDisplayString(_ctx.modelsYearListFiltered.length), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("ul", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      class: "me-2",
                      id: _ctx.state.currentPage === 1 ? 'btnPaginationOff' : 'btnPagination',
                      disabled: _ctx.state.currentPage === 1,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCurrentPage(_ctx.state.currentPage - 1)))
                    }, _hoisted_27, 8, _hoisted_25),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginasNumeradas, (number, key) => {
                      return (_openBlock(), _createElementBlock("div", { key: key }, [
                        (
                  (_ctx.state.currentPage < 4 ? key + 1 >= 1 && key + 1 <= 6 : key + 1 >= _ctx.state.currentPage - 3 && key + 1 <= _ctx.state.currentPage + 3) ||
                  (_ctx.pageCount - _ctx.state.currentPage < 4
                    ? key + 1 >= _ctx.pageCount - 6 && key + 1 <= _ctx.pageCount
                    : key + 1 >= _ctx.state.currentPage - 3 && key + 1 <= _ctx.state.currentPage + 3)
                )
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.setCurrentPage(number)),
                              class: "cursor-pointer",
                              id: number == _ctx.state.currentPage ? 'exibOk' : 'exibRed'
                            }, _toDisplayString(number), 9, _hoisted_28))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    (_ctx.pageCount !== _ctx.state.currentPage)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                          _createTextVNode(" ... "),
                          _createElementVNode("span", {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCurrentPage(_ctx.pageCount))),
                            class: "ms-2 me-1 cursor-pointer"
                          }, _toDisplayString(_ctx.pageCount), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      id: _ctx.state.currentPage === _ctx.pageCount ? 'btnPaginationOff' : 'btnPagination',
                      disabled: _ctx.state.currentPage === _ctx.pageCount,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setCurrentPage(_ctx.state.currentPage + 1)))
                    }, _hoisted_33, 8, _hoisted_31)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      : (_openBlock(), _createBlock(_component_filtro_lubrificantes, {
          key: 1,
          onAlterarExibicao: _cache[4] || (_cache[4] = ($event: any) => (_ctx.alterarExibição($event)))
        })),
    _createVNode(_component_ModalInserirNosSelecionados, { "clicked-all-veiculos": _ctx.clickedAllVeiculos }, null, 8, ["clicked-all-veiculos"]),
    _createVNode(_component_ModalExcluirSelecionados, { "clicked-all-veiculos": _ctx.clickedAllVeiculos }, null, 8, ["clicked-all-veiculos"]),
    (_ctx.cleanModal)
      ? (_openBlock(), _createBlock(_component_ModalEditarUnicoSelecionado, {
          key: 2,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeModal($event))),
          "clean-modal": _ctx.cleanModal,
          "tipos-de-produtos-ref": _ctx.tiposDeProdutosRef,
          "products-marcas": _ctx.productsMarcas,
          "target-click-car": _ctx.targetClickCar
        }, null, 8, ["clean-modal", "tipos-de-produtos-ref", "products-marcas", "target-click-car"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalExcluirUnicoVeiculo, {
      "target-click-car": _ctx.targetClickCar,
      "products-filtered": _ctx.productsFiltered
    }, null, 8, ["target-click-car", "products-filtered"]),
    _createVNode(_component_ModalEnviarPlanilha, { "products-marcas": _ctx.productsMarcas }, null, 8, ["products-marcas"])
  ]))
}